import { Geometry, GeometryObject } from 'geojson';
import { Layer } from './layer/layer.model';
import { MarkerGeometry } from './map.service';

/**
 * This class describes rendered map object like polygon, point, marker, etc.
 */
export class MapElement<T extends MarkerGeometry, TProperties = any> {
  public id: string | number;
  public layer: Layer;
  public properties: TProperties;
  public type: string;
  public geometry: T;

  constructor(id, layer, properties, type, geometry) {
    this.id = id;
    this.layer = layer;
    this.properties = properties;
    this.type = type;
    this.geometry = geometry;
  }
}
